import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Config } from 'src/app/models/config.model';
import { UserInfo } from 'src/app/models/user-info.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigService } from 'src/app/services/config.service';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  title: string = 'Finansklagenemnda - Klageskjema';

  user: UserInfo | null;
  config!: Config | null;

  isMobile!: boolean;

  get loggedIn(): boolean {
    return this.authenticationService.isLoggedIn;
  }


  constructor(
    private authenticationService: AuthenticationService,
    private subscribableTitleService: TitleService,
    private configService: ConfigService,
    private observer: BreakpointObserver,
    private router: Router) {

    this.user = this.authenticationService.userInfo;

    this.subscribableTitleService.title.subscribe(title => {
      this.title = title;
    });

    this.configService.config
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (config: Config | null) => {
          if (config !== null) {
            this.config = config;
          }
        }
      )

    this.observer.observe(['(max-width: 800px)'])
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe((screenSize) => {
      if (screenSize.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });



  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  navigate(url: string): void {
    this.router.navigateByUrl(url);
  }

  logout(): void {
    this.authenticationService.logout();
  }

}
